import Epic from 'components/framework/models/Epic';
import RecordFields from '../RecordFields';
import { registerRecordFieldsClasses } from './index';

export default class EpicFields extends RecordFields {
  static modelClass = Epic;
}

registerRecordFieldsClasses({ EpicFields });
